import FormOperations from "src/utils/dbOperations/formOperations";
import DBOperations from "src/utils/dbOperations";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
import Helper from "src/utils/helper";

const tableName = Constants.enums.TABLES_NAME_ENUM.DYNAMIC_FROMS_TABLE;

async function createNewForm(data) {
  try {
    return await FormOperations.insertData(tableName, data);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateForm(data) {
  try {
    let col_list = [];

    // Iterate through the schema object
    for (const key in JSON.parse(data.form_schema).schema) {
      if (JSON.parse(data.form_schema).schema.hasOwnProperty(key)) {
        if (!JSON.parse(data.form_schema).schema[key].dbCol.includes("_btn_")) {
          col_list.push(JSON.parse(data.form_schema).schema[key].dbCol);
        }
      }
    }
    await FormOperations.checkAndUpdateTable(data.table_name, col_list);
    return await FormOperations.updateData(tableName, removeKeysWithObj(data));
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
function removeKeysWithObj(data) {
  Object.keys(data).forEach((key) => {
    if (key.includes("_obj")) {
      delete data[key];
    }
  });

  // Return the updated object
  return data;
}
async function deleteForm(id) {
  try {
    let data = {
      id,
      is_deleted: true
    };
    let _res = await FormOperations.updateData(tableName, data);
    return { data, ..._res };
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function recoverForm(id) {
  try {
    let data = {
      id,
      is_deleted: false
    };
    let _res = await FormOperations.updateData(tableName, data);
    return { data, ..._res };
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getForm(id) {
  try {
    return await FormOperations.getData(tableName, id);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getFormByTag(tag) {
  try {
    return await FormOperations.getDataByTag(tableName, tag);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getFormBySlug(slug) {
  try {
    return await FormOperations.getDataBySlug(tableName, slug);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getForms(config) {
  try {
    return await FormOperations.fetchData(
      tableName,
      config.fetchDeleted,
      config.searchTxt,
      config.sortField,
      config.sortOrder,
      config.page,
      config.rows
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function formSubmision(tableName, data) {
  try {
    // Submitting form
    return await FormOperations.insertData(tableName, data);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getSubmittedFormById(tableName, id) {
  try {
    return await DBOperations.getData(tableName, id);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  createNewForm,
  updateForm,
  getForms,
  getForm,
  getFormByTag,
  getFormBySlug,
  deleteForm,
  recoverForm,
  formSubmision,
  getSubmittedFormById
};
